<app-nav-menu></app-nav-menu>
<div class="container mt-3 height-100">
  @if (resultLoader) {
    <div style="width:100%;top:0;left:0;bottom:0;position:fixed;background:#000000e8;z-index:500;">
      <div class="loaderforPassenger">
        Loading
        <span class="loadspan"></span>
      </div>
    </div>
  }
  <span class="text-success mb-5">Dashboard <i class="fas fa-angle-right"></i> Search (Step 1) <i class="fas fa-angle-right"></i> Select Plan (Step 2)</span>
  <div class="section_our_solution" id="resultsSection">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-12">
        @if (genericResponse.genericResponse.availablePlansRevenue.length > 0) {
          <div class="our_solution_category">
            @for (plan of genericResponse.genericResponse.availablePlansRevenue; track plan; let f = $index) {
              <div class="solution_cards_box">
                <div class="solution_card" id="solution_card{{f}}" (click)="planDetailsDisplay(plan,f)">
                  <div class="hover_color_bubble"></div>
                  <div class="so_top_icon">
                    <!--<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 16 16" fill="currentColor">
                    <path fill-rule="evenodd" d="M3,1 C3,0.44772 3.44772,0 4,0 L6,0 C6.55228,0 7,0.44772 7,1 L7,2 C7,2.55228 6.55228,3 6,3 L4,3 C3.44772,3 3,2.55228 3,2 L3,1 Z M2,1 L0,1 L0,14 L10,14 L10,1 L8,1 L8,2.4 L8.6,2.4 L8.6,12.6 L1.4,12.6 L1.4,2.4 L2,2.4 L2,1 Z M4.57808,10.0212 L7.9899,6.6094 L6.99996,5.61945 L4.57808,8.04132 L3.36715,6.83038 L2.3772,7.82033 L4.57808,10.0212 Z" transform="translate(3 1)" />
                  </svg>-->
                  <img src="assets/img/trv-1.jpg" />
                  <span class="plan-title-in-img">{{plan.planTitle}}</span>
                </div>
                <div class="solu_title">
                  <h3>Starting from {{plan.currencyCode}}{{plan.totalPremiumAmount}}</h3>
                </div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div style="width:100%;background:transparent;">
          <div class="NoPlansFont">
            No Plans Available For This Selection At The Moment!
          </div>
        </div>
      }
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12 border-dark">
      <div class="bg-secondary text-light border px-3 py-3 text-center">
        Traveller Summary
      </div>
      <div class="table px-2 py-3">
        <div class="row">
          <span class="col-6 right-left-output">Adult</span>
          <span class="col-6 right-right-output">{{genericReqData.totalAdults}}</span>
        </div>
        <div class="row mt-1">
          <span class="col-6 right-left-output">Child</span>
          <span class="col-6 right-right-output">{{genericReqData.totalChild}}</span>
        </div>
        <div class="row mt-1">
          <span class="col-6 right-left-output">Infant</span>
          <span class="col-6 right-right-output">{{genericReqData.totalInfants}}</span>
        </div>
      </div>
      <hr />
      <div class="table px-2 py-3">
        <!--<div class="row">
        <span class="col-6 right-left-output">Travel Duration</span>
        <span class="col-6 right-right-output">-</span>
      </div>
      <div class="row mt-1">
        <span class="col-6 right-left-output">Plan Duration</span>
        <span class="col-6 right-right-output">-</span>
      </div>-->
      <div class="row mt-1">
        <span class="col-6 right-left-output">Departure</span>
        <span class="col-6 right-right-output">{{genericReqData.fromCountryName}}</span>
      </div>
      <div class="row mt-1">
        <span class="col-6 right-left-output">Arrival</span>
        <span class="col-6 right-right-output">{{genericReqData.toCountryName}}</span>
      </div>
      <div class="row mt-1">
        <span class="col-6 right-left-output">Issue Date</span>
        <span class="col-6 right-right-output">{{genericReqData.departDateTime}}</span>
      </div>
      <div class="row mt-1">
        <span class="col-6 right-left-output">End Date</span>
        <span class="col-6 right-right-output">{{genericReqData.returnDateTime}}</span>
      </div>
    </div>
    <hr />
    <div class="table px-2 py-3">
      <div class="row">
        <div class="col-6 right-left-output">Selected Plan</div>
        <div class="col-6 right-right-output">Amount</div>
      </div>
      <div class="row mt-1">
        <div class="col-6 right-left-output">{{planTitle}}</div>
        <div class="col-6 right-right-output">{{currencyCode}}{{totalPremium}}</div>
      </div>
      <!--<div class="mt-1"><span class="right-left-output">Plan Type: </span> <span class="right-right-output">{{planType}}</span></div>-->
    </div>
  </div>
</div>
<hr />
<div class="row mt-3">
  <div class="col-lg-4 col-md-4 col-sm-12 mb-1">
    <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="toPlanSearch()"><i class="fas fa-angle-double-left"></i> Search  </button>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-12 mb-1">
    <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="showDialog()"><i class="fas fa-angle-double-left"></i> Email Quotation <i class="fas fa-angle-double-right"></i> </button>
  </div>
  <div class="col-lg-4 col-md-4 col-sm-12">
    <button type="button" class="subscribe btn btn-block shadow-sm text-uppercase" (click)="toPassengersDetails()"> Continue <i class="fas fa-angle-double-right"></i> </button>
  </div>
</div>
</div>
<p-drawer [(visible)]="planDetailsVisible0" position="right">
  <div [innerHTML]="planContent"></div>
</p-drawer>
<p-dialog header="Quotation Email" [(visible)]="displayEmail">
  <span class="mt-4">
    <label class="d-block mb-1" for="float-input-name">Traveller Name:</label>
    <input id="float-input-name" class="p-1 w-100" type="text" [(ngModel)]="customerName" pInputText>
  </span>
  <span class="mt-4">
    <label class="d-block mb-1" for="float-input-email">Email:</label>
    <input id="float-input-email" type="text" class="p-1 w-100" [(ngModel)]="emailAddress" pInputText>
  </span>
  <button class="btn btn-success mt-4 p-1 w-100" (click)="emailPlan()"> Send </button>
</p-dialog>
</div>
